<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
    <path
      d="M17.3333 9C17.3333 7.4087 16.7714 5.88258 15.7712 4.75736C14.771 3.63214 13.4145 3 12 3C10.5855 3 9.22896 3.63214 8.22876 4.75736C7.22857 5.88258 6.66667 7.4087 6.66667 9C6.66667 16 4 18 4 18H20C20 18 17.3333 16 17.3333 9Z"
    />
    <path
      d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6981 21.5547 10.4458 21.3031 10.27 21"
    />
  </svg>
</template>
